export default "__VITE_ASSET__c2K9WDVP__"